import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Card, PageHeader, Button, Empty, Spin } from 'antd'
import useSWR from 'swr'
import { useSnapshot } from 'valtio'

import tableStore from '../../lib/store/playlist_table'
import PlaylistService from '../../network/services/playlist'
import { serialize } from '../../network/request'
import PlaylistTable from './PlaylistTable'

const PlaylistPage = () => {
  const navigate = useNavigate()
  const primaryAction = (
    <Button
      key="add"
      type="primary"
      onClick={() => {
        navigate('new')
      }}
    >
      Create Playlist
    </Button>
  )

  return (
    <PageHeader title="All Playlists" extra={[primaryAction]}>
      <Card>
        <PlaylistTableWrapper />
      </Card>
    </PageHeader>
  )
}

const PlaylistTableWrapper = () => {
  const { state } = useSnapshot(tableStore)

  // use this to preload
  const { data: response, error } = useSWR(
    serialize(PlaylistService.getAll, { page: 1, limit: state.pageSize, ...state.filters })
  )

  if (error) {
    console.log(error)
    return <Empty description={error?.message ?? 'Please try again later'} />
  }

  if (!response) {
    return <Spin />
  }

  const { total } = PlaylistService.toPaginate(response)

  return (
    <>
      <PlaylistTable total={total} />
      {/* preload next page */}
      {state.currentPage * state.pageSize < total && (
        <div style={{ display: 'none' }}>
          <PlaylistTable total={total} overridePage={state.currentPage + 1} />
        </div>
      )}
    </>
  )
}

export default PlaylistPage
